<script setup lang="ts">
  /**
   * Dialog 标题组件
   * @description
   * 1. 弹窗的主标题
   * 2. 具有语义化的可访问性支持
   */
  import type { DialogTitleProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { DialogTitle, useForwardProps } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'

  const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>()

  const delegatedProps = reactiveOmit(props, 'class')

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DialogTitle
    v-bind="forwardedProps"
    :class="cn('text-lg font-semibold leading-none tracking-tight', props.class)"
  >
    <slot />
  </DialogTitle>
</template>
